import { notification } from "antd"
import { AxiosError } from "axios"
import { useMutation, useQuery, useQueryClient } from "react-query"
import { createFilters, CreateReportFilterRequest, deleteFilters, getFilters, sortFilters } from "./datacenterApi"
import { DatacenterReportType, ReportFilterViewModel } from "./datacenterModel"

export const useGetFiltersQuery = (reportTypeId: DatacenterReportType) => {
  return useQuery(['filters', reportTypeId], {
    queryFn: () => getFilters(reportTypeId),
    refetchOnWindowFocus: false
  })
}

export const useCreateFiltersMutation = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: ({ request }: { request: CreateReportFilterRequest, reportType: DatacenterReportType }) => createFilters(request),
    onSuccess: (_, { reportType }) => {
      queryClient.invalidateQueries(['filters', reportType])
    },
    onError: (error: AxiosError) => {
      notification.error({ message: error.response?.data as string || 'Error creating filter' })
    }
  })
}

export const useDeleteFiltersMutation = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: ({ filtersIds }: { filtersIds: string[], reportType: DatacenterReportType }) => deleteFilters(filtersIds),
    onSuccess: (_, { reportType }) => {
      queryClient.invalidateQueries(['filters', reportType])
    }
  })
}

export const useSortFiltersMutation = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: ({ filterIds }: {filtersList: ReportFilterViewModel[], filterIds: Record<string, number>[], reportType: DatacenterReportType}) => sortFilters(filterIds),
    onMutate: async ({ filtersList, reportType }) => {
      await queryClient.cancelQueries(['filters', reportType])

      const previousFilters = queryClient.getQueryData<ReportFilterViewModel[]>(['filters', reportType]) || []

      queryClient.setQueryData(['filters', reportType], filtersList)

      return { previousFilters, filtersList }
    },
    onSuccess: (_, { reportType }) => {
      queryClient.invalidateQueries(['filters', reportType])
    }
  })
}